module.exports = __webpack_public_path__ + "static/media/objects_14.17e46ee5.svg";